import { useDispatch } from 'react-redux';

import { Input } from 'antd';

import { ChatFilterTypeEnum } from '../../../../shared/constants/enums';
import { AppDispatch } from '../../../../store';
import { ChatsCollection, FetchChatParams } from '../../models';
import * as actions from '../../store/actions';

import './styles.less';

export type ChatSearchProps = {
  setFetchChatData: React.Dispatch<React.SetStateAction<FetchChatParams | undefined>>;
  searchValue: string;
  setSearchValue: (value: string) => void;
  setPageNumber: (pageNumber: number) => void;
  chatFilterValue: ChatFilterTypeEnum;
};

const ChatSearch = ({ setFetchChatData, searchValue, setSearchValue, setPageNumber, chatFilterValue }: ChatSearchProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const onChatSearch = (value: string) => {
    setPageNumber(1);
    dispatch(actions.setLocalChats({ hasMore: true, chatList: [], lastChangeDateTime: null } as ChatsCollection));
    return setFetchChatData?.({
      pageNumber: 1,
      chatSearchValue: value,
      filter: chatFilterValue,
    });
  };

  const onSearchValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  return (
    <Input.Search
      className="chat-input-search"
      allowClear
      value={searchValue}
      onChange={onSearchValueChange}
      onSearch={onChatSearch}
      placeholder="Filter chats"
    />
  );
};

export default ChatSearch;
